export default "__VITE_ASSET__CDOAEz8Q__"